import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from 'axios'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdCreate } from 'react-icons/md'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import classnames from 'classnames'
import PosStoreForm from '../components/PosStoreForm'
import PosStoreTable from '../components/PosStoreTable'
import PosTaxTable from '../components/PosTaxTable'
import PosPaymentTypeTable from '../components/PosPaymentTypeTable'
import PosScheduleTable from '../components/PosScheduleTable'
import PosShippingTable from '../components/PosShippingTable'
import PosPromoTable from '../components/PosPromoTable'
import PosScheduleSummary from './PosScheduleSummary'

class PosScheduleTab extends React.Component {
  _isMounted = true
  comp = StorageService.getSession('selected_org')

  constructor(props) {
    super(props)
    this.state = {
      Role: this.comp.Role,
      modal: false,
      confirmModal: false,
      isEdit: false,
      tabList: [{ name: 'Schedule' }, { name: 'Schedule Summary' }],
      activeTab: '1',
      redirect: false,
      disableTab: false,
    }
  }

  componentDidMount() {
    //this.getStoreList();
    //this.getUserStore();
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit: id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedStoreId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    })
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      let tabName = this.state.tabList[parseInt(tab) - 1].name

      this.setState({
        activeTab: tab,
      })
    }
  }

  toggleConfirmModal = (name, id) => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedData: name,
      selectedStoreId: id,
    })
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      modal: false,
    })

    if (reload) {
      window.location.reload()
    } else {
      this.getStoreList()
    }
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  delete = () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.selectedStoreId,
      delete_by: user.email,
    }

    axios
      .post(url + ':3001/v1/store/delete', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Store deleted successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ confirmModal: false })
        this.getStoreList()
      })
      .catch(error => {
        alert(error)
      })
  }

  // getUserStore = () => {
  //   const user = StorageService.getSession('user_info');
  //   const comp = StorageService.getSession('selected_org');
  //   const url = process.env.REACT_APP_API_URL;
  //   const data = {
  //     session_key: user.session_key,
  //     CompanyID: comp.CompanyID,
  //     ProfileID: user.userId,
  //   };

  //   axios
  //     .post(url + ':3000/v1/user/getContentAccess', data)
  //     .then(response => {
  //       const result = response.data;
  //       if (result.error == true && result.message != 'Success') {
  //         alert(result.message);
  //         return;
  //       }
  //       StorageService.setSession('user_access', result.data);
  //       //this.getStoreList();
  //     })
  //     .catch(error => {
  //       alert(error);
  //     });
  // };

  getStoreList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const access = StorageService.getSession('user_access')
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3001/v1/store', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            storeList: result.data,
            thFieldList: this.state.storeThList,
            tbFieldList: result.data,
            disableTab: result.data.length > 0 ? false : true,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  store = id => {
    this.props.history.push({
      pathname: '/posstore/' + id,
    })
  }

  render() {
    const { activeTab, Role } = this.state
    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card>
              <CardBody>
                <Nav tabs className="ps-tab">
                  {this.state.tabList.map((item, index) => {
                    return (
                      <NavItem key={item.name}>
                        <NavLink
                          className={classnames({
                            active: activeTab === (index + 1).toString(),
                          })}
                          onClick={() => {
                            this.toggleTab((index + 1).toString())
                          }}
                          disabled={this.state.disableTab}>
                          {item.name}
                        </NavLink>
                      </NavItem>
                    )
                  })}
                </Nav>

                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1" className="py-3">
                    <PosScheduleTable isGlobal={true} {...this.props} />
                  </TabPane>
                  <TabPane tabId="2" className="py-3">
                    <PosScheduleSummary isGlobal={true} {...this.props} />
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/* {(Role === 'Superuser' ||
          Role === 'Admin' ||
          Role === 'Manager' ||
          Role === 'Supervisor' ||
          Role === 'Financial') && (
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card>
                <CardBody>
                  <Nav tabs className="ps-tab">
                    {this.state.tabList.map((item, index) => {
                      return (
                        <NavItem key={item.name}>
                          <NavLink
                            className={classnames({
                              active: activeTab === (index + 1).toString(),
                            })}
                            onClick={() => {
                              this.toggleTab((index + 1).toString());
                            }}
                            disabled={this.state.disableTab}
                          >
                            {item.name}
                          </NavLink>
                        </NavItem>
                      );
                    })}
                  </Nav>

                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1" className="py-3">
                      <PosStoreTable store={this.store} />
                    </TabPane>
                    <TabPane tabId="2" className="py-3">
                      <PosTaxTable isGlobal={true} />
                    </TabPane>
                    <TabPane tabId="3" className="py-3">
                      <PosPaymentTypeTable isGlobal={true} />
                    </TabPane>
                    <TabPane tabId="4" className="py-3">
                      <PosScheduleTable isGlobal={true} {...this.props} />
                    </TabPane>
                    <TabPane tabId="5" className="py-3">
                      <PosShippingTable isGlobal={true} {...this.props} />
                    </TabPane>
                    <TabPane tabId="6" className="py-3">
                      <PosPromoTable isGlobal={true} {...this.props} />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )} */}
        <Modal isOpen={this.state.modal} toggle={this.toggle()} className={this.props.className} centered>
          <PosStoreForm history={this.props.history} onToggleModal={this.toggle} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>

        <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleConfirmModal()}>Delete Store</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to delete {this.state.selectedData} ?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.delete()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </>
    )
  }
}
export default PosScheduleTab
